import FacilityHelmet from "../../../../../Helmets/FacilityHelmet";
import MobileFacilityImageCarousel from "./MobileFacilityImageCarousel";

export default function MobileFacilityPage() {
  return (
    <>
      <FacilityHelmet />
      <MobileFacilityImageCarousel />
    </>
  );
}
